import React from 'react';
import {
    AdminGuard,
    GuestGuard,
    PartnerAgentGuard,
    SupplierGuard
} from '../guards/RolesGuard';
import Register from '../features/auth/register';
import Login from "../features/auth/login";
import Layout from '../container/Layout';
import Profile from '../features/dashboard/profile';
import ResetPassword from '../features/auth/reset-password';
import PurchaseOrder from '../features/dashboard/purchases';
import Invoices from '../features/suppliers-dashboard/invoices';
import PurchaseForm from '../features/dashboard/purchases/purchase-form';
import Reservations from '../features/dashboard/reservations';
import RoomRequests from '../features/dashboard/room-requests';
import SupplierDetails from '../features/dashboard/suppliers/details';
import CreateSupplier from '../features/dashboard/suppliers/create';
import Users from '../features/dashboard/users';
import CompanyUsers from '../features/dashboard/company-users';
import CreateCompanyUser from '../features/dashboard/company-users/create/CreateCompanyUser';
import Calls from '../features/dashboard/calls';
import CallDetails from '../features/dashboard/calls/details/CallDetails';
import DraftsRequests from '../features/dashboard/drafts-requests';
import Callback from '../features/dashboard/callback/Callback';
import Settings from '../features/dashboard/settings/Settings';


export interface RouteDefinition {
    path: string;
    element: JSX.Element;
    guard?: () => boolean;
    index?: string,
    childrens?: RouteDefinition[];
}

export const routes: RouteDefinition[] = [
    // Guest pages should have GuestGuard so everyone can access
    {
        path: '/login',
        element: <Login />,
        guard: GuestGuard,
    },
    {
        path: '/register',
        element: <Register />,
        guard: GuestGuard,
    },
    {
        path: '/reset-password',
        element: <ResetPassword />,
        guard: GuestGuard,
    },
    // Admin pages should have AdminGuard

    // Brokers/Partners should have PartnerAgentGuard for each different role user should be a guard
    {
        path: '/purchase-orders',
        element: <Layout />,
        index: '/purchase-orders',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <PurchaseOrder />
            },
            {
                path: 'create',
                element: <PurchaseForm />
            },
            {
                path: 'edit/:id',
                element: <PurchaseForm />
            }
        ],
    },
    {
        path: '',
        element: <Layout />,
        index: '',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Callback />
            }
        ],
    },
   
	{
        path: '/reservations',
        element: <Layout />,
        index: '/reservations',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Reservations />
            },
        ],
    },
	{
        path: '/calls',
        element: <Layout />,
        index: '/calls',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Calls />
            },
			{
				path: ':id',
				element: <CallDetails />
			}
        ],
    },
	{
        path: '/room-request',
        element: <Layout />,
        index: '/room-request',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <RoomRequests />
            },
        ],
    },
	{
        path: '/drafts',
        element: <Layout />,
        index: '/drafts',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <DraftsRequests />
            },
        ],
    },
	{
        path: '/settings',
        element: <Layout />,
        index: '/settings',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Settings />
            },
        ],
    },
	{
        path: '/users',
        element: <Layout />,
        index: '/users',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <CompanyUsers />
            },
			{
                path: 'create',
                element: <CreateCompanyUser />
            },
			{
                path: 'edit/:id',
                element: <CreateCompanyUser />
            },
        ],
    },
    {
        path: '/suppliers',
        element: <Layout />,
        index: '/suppliers',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Users />
            },
            {
                path: 'supplier/create',
                element: <CreateSupplier />
            },
            {
                path: 'supplier/edit/:id',
                element: <CreateSupplier />
            },
            {
                path: 'supplier/:id',
                element: <SupplierDetails />
            },
        ],
    },
    {
        path: '/profile',
        element: <Layout />,
        index: '/profile',
        guard: PartnerAgentGuard,
        childrens: [
            {
                path: '',
                element: <Profile />
            }
        ],
    },
    {
        path: '/invoices',
        element: <Layout />,
        index: '/invoices',
        guard: SupplierGuard,
        childrens: [
            {
                path: '',
                element: <Invoices />
            }
        ],
    }
];